import api from '@/api/index.js'

const account_journeys = {
  state: {
    loading: false,
    data: [],
    error: null
  },

  mutations: {
    SET_ACCOUNT_JOURNEYS_LOADING: (state, loading) => {
      state.loading = loading
    },
    SET_ACCOUNT_JOURNEYS: (state, journeys) => {
      state.data = journeys
      state.loading = false
    },
    SET_ACCOUNT_JOURNEYS_ERROR: (state, error) => {
      state.error = error
      state.loading = false
    }
  },

  actions: {
    LoadAccountJourneys({commit}, id) {
      commit('SET_ACCOUNT_JOURNEYS_ERROR', null)
      commit('SET_ACCOUNT_JOURNEYS_LOADING', true);
      return api.get(`accounts/${id}/journeys?limit=150&offset=0`)
        .then((response) => {
          commit('SET_ACCOUNT_JOURNEYS', response)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_JOURNEYS_LOADING', false);
          commit('SET_ACCOUNT_JOURNEYS_ERROR', error);
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText);
        })
    }
  }
}

export default account_journeys
